import React from "react";
import OurTeam from "./OurTeam.jsx";
import TestimonialBody from "../TestimonialBody.jsx";
import Breadcrumb from "../Breadcrumb.jsx";

const About = () => {
  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">About Us</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="/">Home</a>
            </li>
            <li className="active">About Us</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="About Us"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "About Us", active: true }
        ]}
      />
      <div className="about-area py-120 mb-30">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left">
                <div className="about-img">
                  <img
                  loading="lazy"
                  role="presentation"
                  decoding="async"
                  fetchpriority="high" src="./assets/img/about/01.jpg" alt="" />
                </div>
                <div className="about-shape">
                  <img
                  loading="lazy"
                  role="presentation"
                  decoding="async"
                  fetchpriority="high" src="./assets/img/shape/01.svg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-right">
                <div className="site-heading mb-3">
                  <span className="site-title-tagline">About Us</span>
                  <h2 className="site-title">
                    Get the Best Job That <span>Fits You And We Create</span>{" "}
                    Unique Experiences
                  </h2>
                </div>
                <p className="about-text">
                At  skilletix, we believe that the right job can transform lives. Our platform is designed to connect job seekers with opportunities that match their skills, passions, and aspirations. With a commitment to innovation and a user-centric approach, we create unique experiences that simplify the job search process and empower individuals to achieve their career goals. Whether you're taking your first step into the workforce or looking for your next big opportunity, we're here to support you every step of the way.
                </p>
                <div className="about-list-wrapper">
                  <ul className="about-list list-unstyled">
                    <li>
                      <div className="about-icon">
                        <span className="fas fa-check-circle"></span>
                      </div>
                      <div className="about-list-text">
                        <p>Find the best job that truly fits your skills and ambitions.</p>
                      </div>
                    </li>
                    <li>
                      <div className="about-icon">
                        <span className="fas fa-check-circle"></span>
                      </div>
                      <div className="about-list-text">
                        <p> Experience a seamless, hassle-free job search journey.</p>
                      </div>
                    </li>
                    <li>
                      <div className="about-icon">
                        <span className="fas fa-check-circle"></span>
                      </div>
                      <div className="about-list-text">
                        <p>Unlock unique opportunities tailored just for you</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <a href="/about" className="theme-btn">
                  Read More <i className="far fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="counter-area pb-120">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="counter-box">
                <div className="icon">
                  <i className="fal fa-users"></i>
                </div>
                <div className="counter-content">
                  <div className="counter-number">
                    <span
                      className="counter"
                      data-count="+"
                      data-to="20"
                      data-speed="3000"
                    >
                      20
                    </span>
                    <span className="counter-sign">M</span>
                  </div>
                  <h6 className="title">Daily Users</h6>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="counter-box">
                <div className="icon">
                  <i className="fal fa-address-book"></i>
                </div>
                <div className="counter-content">
                  <div className="counter-number">
                    <span
                      className="counter"
                      data-count="+"
                      data-to="50"
                      data-speed="3000"
                    >
                      50
                    </span>
                    <span className="counter-sign">K</span>
                  </div>
                  <h6 className="title">Job Positions</h6>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="counter-box">
                <div className="icon">
                  <i className="fal fa-smile"></i>
                </div>
                <div className="counter-content">
                  <div className="counter-number">
                    <span
                      className="counter"
                      data-count="+"
                      data-to="30"
                      data-speed="3000"
                    >
                      30
                    </span>
                    <span className="counter-sign">M</span>
                  </div>
                  <h6 className="title">Happy Clients</h6>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="counter-box">
                <div className="icon">
                  <i className="fal fa-buildings"></i>
                </div>
                <div className="counter-content">
                  <div className="counter-number">
                    <span
                      className="counter"
                      data-count="+"
                      data-to="50"
                      data-speed="3000"
                    >
                      50
                    </span>
                    <span className="counter-sign">k</span>
                  </div>
                  <h6 className="title">Total Employers</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <TestimonialBody />
      <OurTeam />
    </>
  );
};

export default About;
